<template>
  <div>
    <h1 class="text-white mb-8 font-bold text-3xl">Transacciones</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="mt-1 w-full form-select">
          <option :value="null" />
          <option value="with">With Trashed</option>
          <option value="only">Only Trashed</option>
        </select>
      </search-filter>
      <inertia-link  class="px-8 py-4 btn-indigoOrange" :href="route('transacciones.create')">
        <span>Reporte</span>
        <span class="hidden md:inline">Diario</span>
      </inertia-link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold" style="background-color: black; color: white;">
               <th class="px-6 pt-6 pb-4">Nº</th>
               <th class="px-6 pt-6 pb-4">Comercio</th>
               <th class="px-6 pt-6 pb-4">Cliente</th>
               <th class="px-6 pt-6 pb-4">Monto</th>
               <th class="px-6 pt-6 pb-4">Fecha</th>
          <th class="px-6 pt-6 pb-4" colspan="2">Estado</th>
        </tr>
        <tr v-for="transaccion in transacciones.data" :key="transaccion.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('transacciones.edit', transaccion.id)" tabindex="-1">
              {{ transaccion.id }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('transacciones.edit', transaccion.id)" tabindex="-1">
              {{ transaccion.comercio }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('transacciones.edit', transaccion.id)" tabindex="-1">
              {{ transaccion.cliente }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('transacciones.edit', transaccion.id)" tabindex="-1">
              {{ transaccion.monto }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('transacciones.edit', transaccion.id)" tabindex="-1">
              {{ transaccion.fecha }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('transacciones.edit', transaccion.id)">
              {{ transaccion.status }}
            </inertia-link>
            </td>
          </tr>
        <tr v-if="transacciones.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No Encontramos Transacciones</td>
        </tr>
      </table>
    </div>
    <pagination style="color: #ffffff;" class="mt-6" :links="transacciones.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  metaInfo: { title: 'Transacciones' },
  components: {
    Icon,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    transacciones: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('transacciones'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
